module.exports = __webpack_public_path__ + "img/upmood-logo.78000688.svg";